import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import IconArtifact from '../../../../static/images/Icon_Artifact.svg'
import {
  getArtifactSizeIcon,
  ArtifactSizeStyled
} from '../../../mini/ArtifactSize'
import FlexAlignCenter from '../../../styled/FlexAlignCenter'
import { CoreChoiceMarker, H6QuestName, CaptionLearnerGoal } from '../styles'
import { Caption4 } from '../../../styled/typography/typography'
import MarkdownRenderer from 'react-markdown-renderer'
import customLexicon from '../../../../lexicon/customLexicon'
import defaultLexicon from '../../../../lexicon/default'


const TooltipWrapper = styled.div`
  width: 303px;
`

const TooltipBody = styled.div`
  text-align: left;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  padding: 12px 17px;
`

const BannerTop = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 3px 17px;
  background: #${props => props.courseColor};
  height: 2px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
`

const ArtifactIcon = styled.div`
  position: relative;
  width: 21px;
  height: 24px;
  background: url(${IconArtifact}) no-repeat;
`

const QuestTooltipMentor = ({
  quest,
  courseColor,
  displayArtifactAndActivityData,
  isActivityCourse,
  orgId
}) => {
  const coreOrChoice = quest.required ?
    (customLexicon[orgId]?.core ? customLexicon[orgId].core : defaultLexicon.core) :
    (customLexicon[orgId]?.choice ? customLexicon[orgId].choice : defaultLexicon.choice)

  const activity = () => {
    if(quest.activities_count > 1) {
      if(!!customLexicon[orgId]?.activity) {
        if (customLexicon[orgId].activity.slice(customLexicon[orgId].activity.length - 1) === ('y')) {
          return customLexicon[orgId].activity.slice(0, -1) + 'ies'
        } else {
          return customLexicon[orgId].activity + 's'
        }
      } else {
        if(defaultLexicon.activity.slice(defaultLexicon.activity.length - 1) === ('y')) {
          return defaultLexicon.activity.slice(0, -1) + 'ies'
        } else {
          return defaultLexicon.activity + 's'
        }
      }
    } else {
      if(!!customLexicon[orgId]) {
        return customLexicon[orgId].activity
      } else {
        return defaultLexicon.activity
      }
    }
  }

  return (
    <TooltipWrapper>
      <BannerTop courseColor={courseColor}></BannerTop>
      <TooltipBody>
        <H6QuestName charcoal4>{quest.name}</H6QuestName>
        <CaptionLearnerGoal charcoal4 className="markdown">
          <MarkdownRenderer
            markdown={quest.learner_goal}
            options={{
              linkTarget: '_blank'
            }}
          />
        </CaptionLearnerGoal>
        <FlexAlignCenter style={{ justifyContent: 'space-between' }}>
          <FlexAlignCenter>
            {!isActivityCourse && (
              <CoreChoiceMarker>
                {coreOrChoice}
              </CoreChoiceMarker>
            )}
            {quest.artifact_types.length > 0 && displayArtifactAndActivityData && (
              <ArtifactIcon>
                <div
                  style={{
                    position: 'absolute',
                    bottom: 0,
                    right: -6
                  }}
                >
                  <ArtifactSizeStyled
                    icon={getArtifactSizeIcon(quest.artifact_types[0].name)}
                  />
                </div>
              </ArtifactIcon>
            )}
          </FlexAlignCenter>
          {displayArtifactAndActivityData && !isActivityCourse && (
            <Caption4 charcoal4>
              {quest.activities_count}{' '}
              {activity()}
            </Caption4>
          )}
        </FlexAlignCenter>
      </TooltipBody>
    </TooltipWrapper>
  )
}

QuestTooltipMentor.defaultProps = {
  displayArtifactAndActivityData: true
}

const mapStateToProps = (state, ownProps) => ({
  orgId: state.organization.orgId,
})

QuestTooltipMentor.propTypes = {
  quest: PropTypes.object.isRequired,
  courseColor: PropTypes.string.isRequired,
  displayArtifactAndActivityData: PropTypes.bool.isRequired
}

export default QuestTooltipMentor
